<template>
  <div class="icon-picker">
    <v-select
      :options="iconOptions"
      :reduce="opt => opt.value"
      label="label"
      :searchable="true"
      :clearable="true"
      :placeholder="placeholder"
      :value="value"
      @input="$emit('input', $event)"
    >
      <!-- option item -->
      <template #option="{ label: optionLabel, value: optionValue }">
        <div class="d-flex align-items-center">
          <component
            :is="getComp(optionValue)"
            class="mr-50"
            size="18"
          />
          <span>{{ optionLabel }}</span>
        </div>
      </template>

      <!-- selected chip -->
      <template #selected-option="{ label: selectedLabel, value: selectedValue }">
        <div class="d-flex align-items-center">
          <component
            :is="getComp(selectedValue)"
            class="mr-50"
            size="18"
          />
          <span>{{ selectedLabel }}</span>
        </div>
      </template>
    </v-select>
  </div>
</template>

<script>
import * as FeatherIcons from 'vue-feather-icons' // all components (e.g., HomeIcon, UserIcon)
import vSelect from 'vue-select'

export default {
  name: 'IconPicker',
  components: {
    'v-select': vSelect,
  },
  props: {
    value: { type: String, default: null }, // v-model holds "HomeIcon", "UserIcon", ...
    placeholder: { type: String, default: 'Select Icon' },
  },
  computed: {
    iconOptions() {
      // Collect every exported component that ends with "Icon"
      return Object.keys(FeatherIcons)
        .filter(name => /Icon$/.test(name))
        .map(name => ({ label: name, value: name }))
        .sort((a, b) => a.label.localeCompare(b.label))
    },
  },
  methods: {
    getComp(name) {
      return FeatherIcons[name] || null
    },
    kebab(name) {
      // HomeIcon -> home-icon (so you could also use <home-icon />)
      return name
        .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
        .replace(/-icon$/, '-icon')
        .toLowerCase()
    },
  },
}
</script>

<style scoped>
.icon-picker :deep(.vs__dropdown-option),
.icon-picker :deep(.vs__selected) {
  display: flex;
  align-items: center;
}
.icon-picker :deep(.mr-50) { margin-right: .5rem; }
.icon-picker :deep(.ml-75) { margin-left: .75rem; }
</style>
